module.exports = __webpack_public_path__ + "media/AUDIO 08.27dc3f31.mp3";